var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfPrevSkip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74166 4.14527C4.88315 4.14527 5.00047 4.1926 5.09363 4.28725C5.1868 4.38191 5.23338 4.49954 5.23338 4.64014L5.23338 11.3773C5.23338 11.5068 5.18575 11.6188 5.09048 11.7135C4.99522 11.8081 4.87685 11.8555 4.73536 11.8555C4.60499 11.8555 4.49322 11.8081 4.40006 11.7135C4.3069 11.6188 4.26031 11.5068 4.26031 11.3773V4.64014C4.26031 4.49954 4.30795 4.38191 4.40321 4.28725C4.49847 4.1926 4.61129 4.14527 4.74166 4.14527ZM11.8154 4.7863C12.0222 4.64612 12.228 4.62807 12.4327 4.73214C12.6374 4.83619 12.7397 5.00552 12.7397 5.24014V10.7606C12.7397 11.001 12.6374 11.1718 12.4327 11.2729C12.228 11.3741 12.0222 11.3602 11.8154 11.2311L7.81543 8.48755C7.65047 8.36362 7.568 8.2008 7.568 7.99909C7.568 7.79737 7.65047 7.63541 7.81543 7.51319L11.8154 4.7863Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfPrevSkip);
export default __webpack_public_path__ + "static/media/pdf-prev-skip.f4ebabe62f6c983894206637d5114836.svg";
export { ForwardRef as ReactComponent };